export enum ChargeStatus {
  // A quote being built — excluded from balances, revenue, and charge lists.
  DRAFT = "DRAFT",
  OUTSTANDING = "OUTSTANDING",
  PAID = "PAID",
  EXTERNAL_SETTLEMENT = "EXTERNAL_SETTLEMENT",
  VOID = "VOID",
  WRITE_OFF = "WRITE_OFF",
  REFUNDED = "REFUNDED",
  PAYMENT_PLAN = "PAYMENT_PLAN",
  CHARGEBACK = "CHARGEBACK",
  COLLECTIONS = "COLLECTIONS",
}

/**
 * Marker on `chargeItem.meta.lineType` for rows whose settlement behavior
 * differs from an ordinary sale. Mirrors `ChargeItemLineType`
 * (decoda/enums/charge_item_line_type.py).
 *
 * A line wearing one of these moves real money, so the marker is stamped when
 * the row is built — never inferred from `description`, which is a display
 * label staff can reproduce in a custom-amount box.
 */
export enum ChargeItemLineType {
  /** Sells patient credit: settlement mints an equal balance. */
  PATIENT_CREDIT_PURCHASE = "PATIENT_CREDIT_PURCHASE",
}
